import { syncFloatingIconsPosition } from '../helpers/utils';
const KUSTOMER_LOADED = 'kustomerLoaded';
function loadKustomerWidget(scriptUrl, apiKey) {
    const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);
    if (existingScript?.dataset.kustomerStarted === 'true') {
        return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
        let scriptEl = existingScript;
        const onKustomerLoaded = () => {
            window.removeEventListener(KUSTOMER_LOADED, onKustomerLoaded);
            scriptEl?.setAttribute('data-kustomer-started', 'true');
            resolve();
        };
        window.addEventListener(KUSTOMER_LOADED, onKustomerLoaded);
        if (existingScript) {
            if (window.Kustomer) {
                onKustomerLoaded();
            }
            return;
        }
        scriptEl = document.createElement('script');
        scriptEl.src = scriptUrl;
        scriptEl.setAttribute('data-kustomer-api-key', apiKey);
        scriptEl.addEventListener('error', () => {
            window.removeEventListener(KUSTOMER_LOADED, onKustomerLoaded);
            reject(new Error('Failed to load Kustomer widget script'));
        });
        // Kustomer requires the embed script in body, not head — see load-chat-asynchronously docs.
        document.body.appendChild(scriptEl);
    });
}
export async function initKustomerLiveChat() {
    const settings = window.UNTUCKitConfig.kustomerLiveChat;
    if (!settings?.toggle || document.body.classList.contains('loggedin-associate')) {
        return;
    }
    try {
        await loadKustomerWidget(settings.scriptUrl, settings.apiKey);
    }
    catch (err) {
        console.error('Failed to load Kustomer live chat script', err);
        return;
    }
    if (!window.Kustomer) {
        console.error('Kustomer not found on window object');
        return;
    }
    console.log('starting Kustomer live chat...');
    window.Kustomer.start({
        brandId: settings.brandId,
        chatIconSize: settings.chatIconSize,
        chatIconPosition: { alignment: 'right', verticalPadding: 10, horizontalPadding: 10 },
        preferredView: settings.preferredView,
    }, () => {
        syncFloatingIconsPosition();
        window.Kustomer?.isChatAvailable?.((result) => {
            console.log('Kustomer chat availability:', result?.availability);
            if (result?.availability === 'hidden' || result?.availability === 'disabled') {
                console.warn('Kustomer chat icon is not shown — check Chat Management settings (business hours, URL overrides, or brand availability).');
            }
        });
    });
}
